import { RiRefreshLine, RiRobot2Line } from 'react-icons/ri';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { useStore } from '../state/store';
import { cn } from '@/lib/utils';

/**
 * AI 供应商 / 模型选择器。
 * 供应商来自服务端注册表（可为自建聚合网关，如 aiproxy），模型可静态配置或从远端拉取。
 */
export function AiModelPicker({ compact = false }: { compact?: boolean }) {
  const providers = useStore(state => state.aiProviders);
  const providerId = useStore(state => state.aiProviderId);
  const model = useStore(state => state.aiModel);
  const models = useStore(state => state.aiModels);
  const setAiProvider = useStore(state => state.setAiProvider);
  const setAiModel = useStore(state => state.setAiModel);
  const refreshAiProviders = useStore(state => state.refreshAiProviders);

  const enabled = providers.filter(p => p.enabled);
  const current = enabled.find(p => p.id === providerId);
  const local = enabled.length === 0;

  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', compact && 'gap-1')}>
      <RiRobot2Line
        className={cn('size-3.5 shrink-0', local ? 'text-muted-foreground' : 'text-[var(--color-lead)]')}
      />

      {local ? (
        <Badge variant="muted">本地启发式（未配置供应商）</Badge>
      ) : (
        <>
          <Select value={providerId ?? ''} onValueChange={value => void setAiProvider(value)}>
            <SelectTrigger className={cn('text-[11px]', compact ? 'h-6 w-[124px]' : 'h-7 w-[150px]')}>
              <SelectValue placeholder="选择供应商" />
            </SelectTrigger>
            <SelectContent>
              {enabled.map(provider => (
                <SelectItem key={provider.id} value={provider.id}>
                  {provider.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Select value={model} onValueChange={setAiModel}>
            <SelectTrigger className={cn('font-mono text-[11px]', compact ? 'h-6 w-[168px]' : 'h-7 w-[200px]')}>
              <SelectValue placeholder="选择模型" />
            </SelectTrigger>
            <SelectContent>
              {models.length === 0 && <SelectItem value={model}>{model || '未配置模型'}</SelectItem>}
              {models.map(item => (
                <SelectItem key={item} value={item}>
                  {item}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Button
            size="icon-sm"
            variant="ghost"
            title={`从「${current?.name ?? '供应商'}」拉取模型清单`}
            onClick={() => void setAiProvider(providerId ?? enabled[0].id)}
          >
            <RiRefreshLine className="size-3" />
          </Button>

          {!compact && (
            <span className="truncate text-[9.5px] text-muted-foreground" title={current?.baseUrl}>
              {current?.baseUrl}
            </span>
          )}
        </>
      )}
    </div>
  );
}